import React from 'react';
import { Heart, MessageCircle, Shield, UserCheck } from 'lucide-react';

export const CoreValues = () => {
  const coreValues = [
    {
      icon: Heart,
      title: 'Respect',
      description: 'Be respectful and kind to all including all your co-workers, clients, patients etc. Be respectful of their request and time.'
    },
    {
      icon: MessageCircle,
      title: 'Communication',
      description: "Communicate properly, let others know if you need help or have time to help, or need training or you are unable to fulfill your duties. Don't wait until the last minute and inconvenience others."
    },
    {
      icon: Shield,
      title: 'Honesty',
      description: 'Sometimes we all make mistakes. Just be honest and admit your flaws.'
    },
    {
      icon: UserCheck,
      title: 'Responsibility',
      description: 'Be Responsible. Take responsibility for your actions and inactions.'
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Our Core Values
          </h2>
          <p className="text-lg text-gray-600">
            The principles that guide everything we do at Capital Billing Services
          </p>
        </div>

        {/* Core Values Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {coreValues.map((value, index) => {
            const Icon = value.icon;
            return (
              <div
                key={index}
                className="group bg-white rounded-2xl p-8 border-2 border-gray-100 hover:border-teal-500 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 text-center"
              >
                <div className="bg-gradient-to-br from-teal-500 to-navy-600 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <Icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                  {value.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {value.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
